import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { fData } from 'src/utils/formatNumber';
import ImageEditorStage from './ImageEditorStage';
import { getFileIcon } from './utils/mediaTypes';

// ----------------------------------------------------------------------
// Área central do preview: imagem (com edição), vídeo ou documento PDF.

export default function MediaPreviewStage({ item, mode, drawColor, onStrokesChange, onApplyCrop, onCancelCrop }) {
    const { t } = useTranslation('chat');

    if (!item) return null;

    if (item.kind === 'image') {
        return (
            <ImageEditorStage
                item={item}
                mode={mode}
                drawColor={drawColor}
                onStrokesChange={onStrokesChange}
                onApplyCrop={onApplyCrop}
                onCancelCrop={onCancelCrop}
            />
        );
    }

    if (item.kind === 'video') {
        return (
            <video
                key={item.id}
                src={item.originalUrl}
                controls
                className="max-w-full max-h-full rounded-xl shadow-sm"
            />
        );
    }

    if (item.kind === 'file') {
        const fileIcon = getFileIcon(item.file);
        return (
            <div className="flex flex-col items-center gap-3 rounded-2xl border border-gray-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 p-8 max-w-sm">
                <Iconify icon={fileIcon.icon} width={64} className={fileIcon.color} />
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 text-center break-all">
                    {item.file?.name}
                </p>
                <p className="text-xs text-gray-500">
                    {t('mediaEditor.document')} · {fData(item.file?.size || 0)}
                </p>
            </div>
        );
    }

    return (
        <div className="w-full h-full max-w-3xl mx-auto flex flex-col gap-3">
            <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 flex-shrink-0">
                <div className="w-9 h-9 rounded-lg bg-red-50 dark:bg-red-500/10 flex items-center justify-center flex-shrink-0">
                    <Iconify icon="mdi:file-pdf-box" width={22} className="text-red-500" />
                </div>
                <div className="min-w-0">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">
                        {item.file?.name}
                    </p>
                    <p className="text-xs text-gray-500">
                        {t('mediaEditor.document')} · {fData(item.file?.size || 0)}
                    </p>
                </div>
            </div>
            <iframe
                key={item.id}
                src={`${item.originalUrl}#toolbar=0&navpanes=0`}
                title={item.file?.name || 'PDF'}
                className="flex-1 min-h-0 w-full rounded-xl border border-gray-200 dark:border-slate-700 bg-white"
            />
        </div>
    );
}
